/**
 * Slice-local constants for the support-inbox `conversation` domain. Every
 * value is lifted verbatim from the cpanel chat feature (`features/chat`) so the
 * behaviour stays 1:1 — named here instead of repeated as magic numbers.
 */

/** Chat-list page size (cpanel `CHAT_PAGE_SIZE` / `SIZE={15}`). */
export const CHAT_PAGE_SIZE = 15;

/** Message-window step: the thread grows by this many messages per page. */
export const MESSAGES_PAGE_SIZE = 15;

/** How often the open chat's presence (`check-online`) is re-polled. */
export const PRESENCE_POLL_MS = 5_000;

/** Operators are listed `limit: 100` at a time (cpanel `getAllAdmins`). */
export const OPERATOR_PAGE_SIZE = 100;

/** Upper bound on operator pages walked, so a misbehaving `count` cannot loop. */
export const OPERATOR_MAX_PAGES = 20;

/** Attachment rules of the composer (cpanel `ChatMessageInput`). */
export const MAX_ATTACHMENT_BYTES = 10 * 1024 * 1024;
export const MAX_ATTACHMENT_LABEL = '10MB';
export const MAX_ATTACHMENTS = 1;

/** The placeholder body cpanel sends with a file-only message. */
export const FILE_ONLY_MESSAGE = 'img';

/**
 * Reply-timer thresholds (cpanel `MessageCountdown`): green under 90 s, yellow
 * from 90 s, red from 120 s since the courier's last message.
 */
export const COUNTDOWN_WARN_SECONDS = 90;
export const COUNTDOWN_DANGER_SECONDS = 120;

/** Realtime chat events refetch the lists at most once per this window. */
export const CHAT_INVALIDATION_THROTTLE_MS = 5_000;

/** Statuses a chat moves through (`chats.status`). */
export const CHAT_STATUS = {
  NEW: 1,
  ACQUIRED: 2,
  CLOSED_RESOLVED: 3,
  CLOSED_NOT_RESOLVED: 4,
} as const;
